
import Chat from './components/Chat';
import { PromptsProvider } from './context/promptsContext';
import { UsersProvider } from './context/usersContext';

function App() {
  return (
    <UsersProvider>
      <PromptsProvider>
        <Chat />
      </PromptsProvider>
    </UsersProvider>
  );
}

export default App;
